import environment from "@/constants/Environment";

const envData = environment();
const isFromOutgrow = window.localStorage.getItem("outgrow") === "true";

const enableSupportBot =
  envData.isAI &&
  envData.ENVIRONMENT !== "development" &&
  isFromOutgrow === false;

if (enableSupportBot) {
  init();
}

function init() {
  const baseUrl =
    envData.ENVIRONMENT === "release"
      ? "https://live-release.outgrow.chat"
      : "https://venturepact92.chatbotbuilder.net";

  window.cbbSettings = {
    base_url: baseUrl,
    app_id: "venturepact92-13",
    app_type: "chat",
  };

  const script = document.createElement("script");
  script.id = "cbb-support-bot";
  script.defer = true;
  script.src = baseUrl + "/embed.js";

  document.head.appendChild(script);
}

declare global {
  interface Window {
    cbbSettings: {
      base_url: string;
      app_id: string;
      app_type: "chat" | "voice" | "chat-voice";
      user_data?: Record<string, string>;
    };
    ChatbotBuilder: {
      start(): void;
      open(): void;
      close(): void;
      setUserData(data: Record<string, string>): void;
      getUserData(): Record<string, string>;
      resetChat(): void;
      sendMessage(message: string, role?: "assistant" | "user"): void;
      createContact(data: Record<string, string>): void;
    };
  }
}
